import { AfterContentInit, Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { RequestMaterialDTO, TenderRequestedMaterialDTO } from '../../api/plyca-dtos-v2';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';
import { UIService, generateRandomIdentifier } from '../../ui.service';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { DATEPIPE_DATE_FORMAT } from '../../../services/language.service';
import { FormConfig } from '../../components/forms/form.objects';
import { AppConfiguration } from '../../conf/app.configuration';
import { BaseFormComponent, BaseFormHeaderInfo } from '../../tasks/baseFormComponent/baseForm.component';
import { TaskDTO, TenderV2DTO, getSimpleIdentifierFromString } from '../../api/plyca-dtos';
import * as lodash from 'lodash';

export class TenderRequestedMaterialModel {
  dto: TenderRequestedMaterialDTO;
}

@Component({
  selector: 'tender-material',
  templateUrl: '../../tasks/baseFormComponent/baseForm.template.html',
  providers: [DialogService, UIService]
})
export class TenderRequestedMaterialComponent
  extends BaseFormComponent<TenderRequestedMaterialDTO, TenderRequestedMaterialModel>
  implements AfterContentInit, OnDestroy, OnInit {
  public DATEPIPE_DATE_FORMAT = DATEPIPE_DATE_FORMAT;

  public translate: TranslateService;

  private TRM: TenderRequestedMaterialDTO;
  private tender: TenderV2DTO;
  private readonly = false;
  private identifier: string;

  updateMode = false;
  insertMode = false;
  showLotes = false;






  constructor(
    elem: ElementRef,
    public translationService: TranslateService,
    public dialogConfig: DynamicDialogConfig,
    public dialogService: DialogService,
    public appConfig: AppConfiguration,
    private plycaErrorHandler: PlycaErrorHandler,
    public ref: DynamicDialogRef
  ) {
    super(elem);


    this.windowHash = generateRandomIdentifier();

    // Si se abre un evento existente llega en el context
    let context = dialogConfig['context'];
    this.tender = context['tender'];
    this.showLotes = this.tender['project'].breakdownLot.apportioned === true;
    this.readonly = context['readonly'] ? context['readonly'] : false;

    if (context) {
      if (context && context.element && context.element.identifier) {
        this.updateMode = true;
        this.TRM = context['element'];
      } else {
        this.insertMode = true;
        this.TRM = new TenderRequestedMaterialDTO();
      }

    } else {
      // Si no llegan los datos del evento es un evento nuevo
      this.TRM = new TenderRequestedMaterialDTO();
      this.insertMode = true;
    }

    this.task = dialogConfig?.data?.task;
  }


  // Metodos obligatorios
  dtoToModel(dto: TenderRequestedMaterialDTO): Observable<TenderRequestedMaterialModel> {
    let model = new TenderRequestedMaterialModel();

    if (JSON.stringify(dto) === '{}') {
      dto.tender = new TenderV2DTO();
      dto.tender.division = this.tender.division;
      dto.tender.division.identifier = getSimpleIdentifierFromString(this.tender.division.identifier);
      dto.tender.documentClass = this.tender.documentClass;
      dto.tender.orderNumber = this.tender.orderNumber;

    }
    model['ui'] = {};
    model['ui']['project'] = this.tender['project'];
    model['ui']['projectDes'] = this.tender['project'].identifier + ' ' + this.tender['project']?.contractFolderId;

    if (this.showLotes) {
      model['ui']['lotesDes'] = this.tender.tenderLots.map((tl => { return tl.procurementProjectLot.lotId }))
      model['ui']['lotesDes'] = '' + model['ui']['lotesDes'] + '';


      model['ui']['lotNumberDes'] = this.tender.tenderLots.map((tl => { return tl.procurementProjectLot.lotNumber }))
      model['ui']['lotNumberDes'] = '' + model['ui']['lotNumberDes'] + '';
    }


    if (this.task) {
      // se clona la configuracion para no modificarla con el interface
      dto['context'] = lodash.cloneDeep(this.task.work.context);

      dto.task = {} as TaskDTO;
      dto.task.identifier = this.task.identifier;

    }


    model.dto = dto;


    return of(model);


  }
  modelToDTO(model: TenderRequestedMaterialModel): TenderRequestedMaterialDTO {

    let dto = model.dto;
    let identifier = getSimpleIdentifierFromString(model.dto.requestedMaterial.identifier);
    delete dto.requestedMaterial;
    dto.requestedMaterial = new RequestMaterialDTO();
    dto.requestedMaterial.identifier = identifier;



    // igual no hace falta por que no hay tablas
    dto = JSON.parse(
      JSON.stringify(dto, (k, v) => (k === '_parent' ? undefined : v))
    );
    return dto;
  }


  getTitle(model: TenderRequestedMaterialDTO): string {
    return model.identifier;
  }

  getHeaderInfo(): BaseFormHeaderInfo {

    return undefined;
  }

  getServiceURL(): string {
    return this.configuration.TENDER_REQUESTEDMATERIAL_SERVICE_URL;
  }

  getObjectIdentifier(): string {
    return this.TRM.identifier;
  }
  getFormSettingURL(): string {
    return 'requestedMaterial/TenderRequestedMaterialSettings.json';
  }

  initHeaderActions() {
    if (this.readonly === false) {
      this.subscribe(
        this.headerActionsService
          .addWindowAction(
            'General.save',
            'fas fa-lg fa-check',
            'btn-primary',
            true,
            this.windowHash,
            !this.readonly
          )
        , (success) => {
          this.guardar();
        });
    }
    this.subscribe(
      this.headerActionsService.addWindowAction(
        'General.close',
        'fas fa-times',
        'btn-outline-secondary',
        true,
        this.windowHash
      ),
      (success) => {
        this.ref.close();
      }
    );
  }


  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    formConfig.showValidations = true;
    formConfig.isModalWindow = true;

    formConfig.readonly = this.readonly;

    formConfig.windowHash = this.windowHash;

    formConfig.functions.push({
      identifier: 'checkDivision',
      fn: this.checkDivision
    });




    return of(formConfig);
  }

  checkDivision(model: any) {

    let div = model.ui.taskdivision + '<>' + model.dto.project.identifier;
    if (model.ui.divisions) {
      model.dto.division = model.ui?.divisions.find(element => element.identifier === div);
    }


  }

  guardar() {
    this.subscribe(this.save(),

      (newEvent: TenderRequestedMaterialDTO) => {
        this.waitService.cancelWaiting();
        this.uiService.showSuccess(
          this.translate.instant('RequestedMaterial.accion.save.ok'),
          this.translate.instant('General.info'),
          'success'
        );
        this.ref.close(newEvent);
      }


    );




  }

  modalError(error) {
    this.ref.close();
    this.plycaErrorHandler.showServerError(error);

  }
  ngOnDestroy() {
    this.dialogConfig = null;
    this.ref = null;
    super.ngOnDestroy();
  }



  /*
    getObjectParams(): { [param: string]: string | string[]; } {

      return {

        // 'expand': 'entityDTO,unitParent,customFields,entityDTO.customFields,expansionSet:addresses'
        'projectId': this.TRM.division.project.identifier,
        'divisionId': getSimpleIdentifierFromString(this.TRM.division.identifier),
        'orderNumber': this.TRM.orderNumber + '',
        'documentClassId': this.TRM.documentClass.identifier,
      };


    }*/
}
